'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import styles from '../auth.module.css';
import { useBoundaryErrorReport } from '@/lib/observability/report-boundary-error';

export default function LoginError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useBoundaryErrorReport('auth/login', error);
  const tc = useTranslations('common');
  const t = useTranslations('auth');

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>
          <span className={styles.logoText}>{tc('appName')}</span>
        </div>
        <h1 className={styles.heading}>{tc('error')}</h1>
        <p className={styles.subheading}>{t('errorPage.messageLogin')}</p>
        <div className={styles.errorActions}>
          <Button onClick={reset} fullWidth>
            {tc('retry')}
          </Button>
          <div className={styles.links}>
            <Link href="/">{t('errorPage.goHome')}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
